let appUrl = `//${document.location.host}/`;
let environment = "PRODUCTION";
if (appUrl.endsWith(":3000/")) {
	appUrl = "https://betaffiliation.ddev.site/";
	// appUrl = "https://staging2.betaffiliation.com/";
	// appUrl = "https://betaffiliation.com/";
	// appUrl = "https://network.nsgsocialwebsrl.com/";
	environment = "DEVELOPER";
}
export const APP_URL = appUrl;
export const API_URL = `${APP_URL}api`;
export const SIGNUP_URL = `${APP_URL}signup/`;
export const VERSION = "1.0.0";
export const ENVIRONMENT = environment;
// Google reCAPTCHA v3 site key (same key as the contact form on the public site)
export const RECAPTCHA_SITE_KEY = "6Ldt6MQhAAAAABrLEFbKnUAX-mTb1sUqLlA8dkz4";
